module.exports = __webpack_public_path__ + "img/expodecor_vintage_wooden_floor.7474bf87.jpg";